<script>
import Spacer from 'linna/components/Spacer'

import Led from '@/components/snippets/Led'
import StyledButton from '@/components/snippets/StyledButton'

export default {
  name: 'Radio',

  components: {
    Led,
    Spacer,
    StyledButton
  },

  props: {

    radioId: {
      type: String,
      required: true
    }

  },

  data () {
    return {
      message: 'ping'
    }
  },

  computed: {

    radio () {
      return this.$store.getters.radioById(this.radioId)
    },

    ownRadioTransmissions () {
      return this.$store.getters.radioTransmissionsOfRadioId(this.radioId)
    },

    ownRadioTransmission () {
      return this.ownRadioTransmissions
        ? this.ownRadioTransmissions[0]
        : null
    },

    frequencyIsAtMin () {
      return this.frequency <= this.radio.minFrequency
    },

    frequencyIsAtMax () {
      return this.frequency >= this.radio.maxFrequency
    },

    frequency: {

      get () {
        return parseFloat(this.radio.frequency)
      },

      set (value) {
        this.$store.dispatch('changeRadioFrequency', {
          id: this.radio.id,
          frequency: value
        })
      }

    }

  },

  methods: {

    decreaseFrequency () {
      this.frequency--
    },

    increaseFrequency () {
      this.frequency++
    },

    startRadioTransmission () {
      // Only start one transmission
      if (!this.ownRadioTransmissions) {
        this.$store.dispatch('startRadioTransmission', {
          radioId: this.radioId,
          message: this.message,
          frequency: this.radio.frequency,
          originX: this.radio.locationX,
          originY: this.radio.locationY,
          range: this.radio.range
        })
      }
    },

    endRadioTransmission () {
      if (this.ownRadioTransmissions) {
        this.ownRadioTransmissions.forEach((radioTransmission) => {
          this.$store.dispatch('endRadioTransmissionById', radioTransmission.id)
        })
      }
    }

  }

}
</script>

<template>
  <div class="c-radio">
    <div class="c-radio-content">

      <div class="c-radio-actions">

        <styled-button
          :disabled="!ownRadioTransmission"
          @click="endRadioTransmission"
        >
          0
        </styled-button>

        <styled-button
          :disabled="!this.message.length || ownRadioTransmission"
          @click="startRadioTransmission"
        >
          1
        </styled-button>

        <spacer />

        <!-- <textfield
          :value.sync="message"
          :inline="true"
        /> -->

        <!-- {{ radio.locationX }} x {{ radio.locationY }} / {{ radio.range }} -->

        <styled-button
          :disabled="frequencyIsAtMin"
          @click="decreaseFrequency"
        >
          -
        </styled-button>

        <div class="c-radio-frequency">
          {{ frequency}} MHz
        </div>

        <styled-button
          :disabled="frequencyIsAtMax"
          @click="increaseFrequency"
        >
          +
        </styled-button>

        <led :on="ownRadioTransmission" />

      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-radio {
  @include pad-loose-even;
  background-color: $very-dark;
}

.c-radio-actions {
  @include flex;
  @include flex-center;
}

.c-radio-frequency {
  @include pad-tight-horizontal;
}

</style>
